// extracted by mini-css-extract-plugin
export var actionButton = "_it-t";
export var buttonContainer = "_it-0";
export var buttonContainer2 = "_it-1";
export var buttonSection = "_it-2";
export var details = "_it-3";
export var dropdownItem = "_it-5";
export var dropdownItemsContainer = "_it-4";
export var fileInput = "_it-r";
export var headerButton = "_it-6";
export var icon = "_it-7";
export var input = "_it-8";
export var macroListItem = "_it-9";
export var mainContent = "_it-a";
export var microText = "_it-b";
export var modal = "_it-w";
export var optionsButton = "_it-c";
export var paperclip = "_it-s";
export var pillContent = "_it-d";
export var preview = "_it-e";
export var preview2 = "_it-f";
export var quillEditor = "_it-q";
export var selectedMacro = "_it-g";
export var sidebar = "_it-h";
export var sidebarHeader = "_it-j";
export var sidebarList = "_it-i";
export var sidebarListItem = "_it-k";
export var sidebarSearch = "_it-l";
export var snoozeDurationWrapper = "_it-v";
export var statusPillContainer = "_it-m";
export var tagsContainer = "_it-n";
export var unselectedMacro = "_it-o";
export var variable = "_it-u";
export var wrapper = "_it-p";